import { render } from "./SiIntroduction_2.vue?vue&type=template&id=55124e99&scoped=true"
import script from "./SiIntroduction_2.vue?vue&type=script&lang=js"
export * from "./SiIntroduction_2.vue?vue&type=script&lang=js"

import "./SiIntroduction_2.vue?vue&type=style&index=0&id=55124e99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55124e99"]])

export default __exports__